import { jsx as _jsx } from "react/jsx-runtime";
import AddIcon from '@mui/icons-material/Add';
import IconButton from '@mui/material/IconButton';
import { TranslatableString } from '@rjsf/utils';
/** The `AddButton` renders a button that represent the `Add` action on a form
 */
export default function AddButton(_ref) {
  let {
    uiSchema,
    registry,
    ...props
  } = _ref;
  const {
    translateString
  } = registry;
  return _jsx(IconButton, {
    title: translateString(TranslatableString.AddItemButton),
    ...props,
    color: 'primary',
    children: _jsx(AddIcon, {})
  });
}